/**
 * Copyright (c) 2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */

import {Injectable} from '@angular/core';
import {FocusTrapDirective} from './focus-trap.directive';
export class FocusTrapTracker {
private _previousFocusTraps: FocusTrapDirective[] = [];
private _current: FocusTrapDirective;
/**
 * @return {?}
 */
get current(): FocusTrapDirective {
        return this._current;
    }
/**
 * @param {?} value
 * @return {?}
 */
set current(value: FocusTrapDirective) {
        this._previousFocusTraps.push(this._current);
        this._current = value;
    }
/**
 * @return {?}
 */
activatePreviousTrapper() {
        this._current = this._previousFocusTraps.pop();
    }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function FocusTrapTracker_tsickle_Closure_declarations() {
/** @type {?} */
FocusTrapTracker.decorators;
/**
 * @nocollapse
 * @type {?}
 */
FocusTrapTracker.ctorParameters;
/** @type {?} */
FocusTrapTracker.prototype._previousFocusTraps;
/** @type {?} */
FocusTrapTracker.prototype._current;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
